<tui-loader size="s" class="row-span-2 self-center" />
<p
	class="m-0 min-w-0 truncate text-left text-xxs text-primary-dark-300"
	data-progress-message
>
	{{ label() }}
</p>
<div class="flex min-w-0 items-center gap-2">
	<progress
		class="h-1 min-w-0 flex-1"
		max="100"
		tuiProgressBar
		[value]="shownPercent()"
		[attr.aria-valuetext]="shownPercent() + '%'"
	></progress>
	<span
		class="w-9 shrink-0 text-left text-xs tabular-nums text-primary"
		data-progress-percent
	>
		{{ shownPercent() }}%
	</span>
</div>
